// extracted by mini-css-extract-plugin
export default {"requestInvoiceContainer":"RequestInvoiceForm_requestInvoiceContainer__wxsmJ","invoiceExplainer":"RequestInvoiceForm_invoiceExplainer__ArXYn"};